import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Cell } from 'recharts'
import { DEFAULT_LANGUAGE } from '../../../../configs/language'
import { ChartContainer } from '../../../common/chart/chartContainer'
import Bar from '../../../common/chart/chartContainer/Bar'
import { Element } from '../../../common/html/element'
import { Notification } from '../../../common/notification'
import { formatByTheme } from '../../../helpers/theme'
import { formatVal } from '../../../helpers/value'
import { MARGIN_LEFT_CHART_DYNAMIC } from '../../../tool/dynamicReport/constant'
import { UseScoreRange } from '../common/hooks/useScoreRange'
import { SCORE_TYPE, VALUE_SCORE } from '../constant'
import { selectScoreActive } from '../store/slice'
import { getDataTable, getDataTablePer } from './store/slice'

export const Chart = ({ isDynamicReport, type }) => {
  const { value: typeValueStore } = useSelector(selectScoreActive)
  const dataTableRisk = useSelector(getDataTable)
  const dataTablePer = useSelector(getDataTablePer)
  const { data } = UseScoreRange(true)

  const typeValue = isDynamicReport ? type : typeValueStore
  const dataTable =
    typeValue === VALUE_SCORE.CREDIT_SCORE ? dataTableRisk : dataTablePer

  const dataChart = useMemo(() => {
    if (typeValue === VALUE_SCORE.CREDIT_SCORE) {
      return data[SCORE_TYPE.CREDIT_RISK].map((item) => ({
        ...item,
        ...dataTable.find((key) => key.name === item?.scoreRangeId),
      }))
    }
    if (typeValue === VALUE_SCORE.PERFORMANCE) {
      return data[SCORE_TYPE.PERFORMANCE].map((item) => ({
        ...item,
        ...dataTable.find((key) => key.name === item?.scoreRangeId),
      }))
    }
  })

  const renderCustomContent = ({ data }) => {
    return (
      <>
        <div>
          {data?.scoreRangeName}&nbsp;
          {data?.scoreRange_Min
            ? `(${data?.scoreRange_Min}-${data?.scoreRange_Max})`
            : Number(data?.scoreRange_Min) === 0
            ? '(0)'
            : ''}
          :&emsp;{data?.value}
        </div>
      </>
    )
  }

  if (isDynamicReport && !dataTable.length) {
    return <Notification isDynamicReport />
  }

  return (
    <>
      <Element
        style={{
          color: '#9C9C9C',
        }}
      >
        <Translate value="portfolioScore.numberOfCompanies" />
      </Element>
      {!!dataChart.length && (
        <ChartContainer
          data={dataChart}
          width="100%"
          height={250}
          margin={{
            left: isDynamicReport ? MARGIN_LEFT_CHART_DYNAMIC : 0,
            right: 0,
            bottom: 10,
          }}
          xAxis={[
            {
              dataKey: 'scoreRangeName',
              height: 32,
              tickStyle: { color: '#3A414B' },
              padding: { left: 10, right: 10 },
              tickMargin: 4,
              lineClamp: 2,
            },
          ]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: ['value'],
              isStackedBar: true,
              tickFormatter: (val) =>
                formatVal(val, DEFAULT_LANGUAGE, false, 0),
              axisLine: { stroke: formatByTheme('#D5D5D5') },
            },
          ]}
          tooltip={{
            schema: {
              renderCustomContent: renderCustomContent,
            },
          }}
        >
          <Bar yAxisId="left" dataKey="value" barSize={30}>
            {dataChart.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color || '#9c9c9c'} />
            ))}
          </Bar>
        </ChartContainer>
      )}
    </>
  )
}
